import OrderCargoOrderChangeApprovalStatusRequest, {
  OrderCargoOrderChangeApprovalStatusRequestBody,
} from "./order-cargo-order-change-approval-status.request";

const createBody = (
  request: OrderCargoOrderChangeApprovalStatusRequest,
): OrderCargoOrderChangeApprovalStatusRequestBody => {
  return {
    status: request.status,
  };
};

const orderCargoOrderChangeApprovalStatusRequestFactory = {
  createBody,
};

export default orderCargoOrderChangeApprovalStatusRequestFactory;
